theme.videoHasSound = (function() {
  var hasSound = document.querySelectorAll('.has-vid-w-sound');

  if(typeof(hasSound) != 'undefined' && hasSound != null){
    hasSound.forEach(function(i) { 
      var video = i.querySelector('video'),
          mute  = i.querySelector('.icon-mute'),
          sound = i.querySelector('.icon-sound');

      mute.addEventListener("click", toggle);
      sound.addEventListener("click", toggle);

      function toggle() {
        for (let sibling of this.parentNode.children) {
          if (sibling !== this) {
            sibling.style.display = "block";
          } else {
            this.style.display = "none";
          }
        }

        if( video.muted ) {
          video.muted = false;
        } else {
          video.muted = true;
        }
      }
    });
  }
})();

theme.videoIsInViewport = (function() {
  var checkView = document.querySelectorAll('video.play-in-view');

  if(typeof(checkView) != 'undefined' && checkView != null){
    checkView.forEach(function(i) { 
      function isInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth) &&
            rect.bottom >= 100 && // 375
            rect.right >= 100 // 375
        );
      }

      if (isInViewport(i)) {
        console.log('load - is in view');
        i.play();
      } else {
        console.log('load - nope');
        i.pause();
      }

      window.addEventListener('scroll', function () {
        if (isInViewport(i)) {
          console.log('scroll - is in view');
          i.play();
        } else {
          console.log('scroll - nope');
          i.pause();
        }
      }, false);
    });
  }
})();